const SortOrder = {
  ASC: 'ASC',
  DESC: 'DESC'
};

export default SortOrder;
